var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoCartillaGris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 112.1",
    style: {
      enableBackground: "new 0 0 85 112.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M84.3,113.5H12.2c-7.3,0-13.3-6-13.3-13.3V11.9c0-7.3,6-13.3,13.3-13.3h72.1c1,0,1.8,0.8,1.8,1.8v111.3 C86.1,112.7,85.3,113.5,84.3,113.5z M12.2,2.2c-5.3,0-9.7,4.3-9.7,9.7v88.3c0,5.3,4.3,9.7,9.7,9.7h70.3V2.2H12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M0.7,102.5c-1,0-1.8-0.8-1.8-1.8c0-7.3,6-13.3,13.3-13.3h72.1c1,0,1.8,0.8,1.8,1.8S85.3,91,84.3,91H12.2 c-5.3,0-9.7,4.3-9.7,9.7C2.5,101.7,1.7,102.5,0.7,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M15.9,91.2c-1,0-1.8-0.8-1.8-1.8v-89c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8v89C17.7,90.4,16.9,91.2,15.9,91.2z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M79.3,99.1H37c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4h42.3c0.8,0,1.4,0.6,1.4,1.4S80.1,99.1,79.3,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M79.3,105.8H17.6c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4h61.7c0.8,0,1.4,0.6,1.4,1.4S80.1,105.8,79.3,105.8z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M27,99.1h-9.4c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4H27c0.8,0,1.4,0.6,1.4,1.4S27.8,99.1,27,99.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M49.3,62.9c-10,0-18.1-8.1-18.1-18.1c0-10,8.1-18.1,18.1-18.1c10,0,18.1,8.1,18.1,18.1 C67.4,54.8,59.3,62.9,49.3,62.9z M49.3,29.5c-8.5,0-15.3,6.9-15.3,15.3s6.9,15.3,15.3,15.3s15.3-6.9,15.3-15.3 S57.8,29.5,49.3,29.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M53.2,55.4h-7.5c-0.6,0-1.2-0.6-1.2-1.2v-4.6h-4.6c-0.6,0-1.2-0.6-1.2-1.2v-7.5c0-0.6,0.6-1.2,1.2-1.2h4.6 v-4.6c0-0.6,0.6-1.2,1.2-1.2h7.5c0.6,0,1.2,0.6,1.2,1.2v4.6H59c0.6,0,1.2,0.6,1.2,1.2v7.7c0,0.6-0.6,1.2-1.2,1.2h-4.6v4.6 C54.1,55,53.8,55.4,53.2,55.4z M46.7,53.2H52v-4.6c0-0.6,0.6-1.2,1.2-1.2h4.6V42h-4.6c-0.6,0-1.2-0.6-1.2-1.2v-4.6h-5.4v4.6 c0,0.6-0.6,1.2-1.2,1.2h-4.6v5.4h4.6c0.6,0,1.2,0.6,1.2,1.2v4.6H46.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCartillaGris);
export default __webpack_public_path__ + "static/media/iconoCartillaGris.028356b7.svg";
export { ForwardRef as ReactComponent };